import { render, staticRenderFns } from "./DetailedTableMaterialVegetal.vue?vue&type=template&id=9335fd22&scoped=true"
import script from "./DetailedTableMaterialVegetal.vue?vue&type=script&lang=js"
export * from "./DetailedTableMaterialVegetal.vue?vue&type=script&lang=js"
import style0 from "./DetailedTableMaterialVegetal.vue?vue&type=style&index=0&id=9335fd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9335fd22",
  null
  
)

export default component.exports